import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { ProviderSite } from '../../models';

@Component({
    selector: 'app-provider-site',
    templateUrl: './provider-site.component.html',
    styleUrls: ['./provider-site.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        FlexLayoutModule,
        MatButtonModule,
        MatCardModule,
        MatIcon
    ]
})
export class ProviderSiteComponent {
    public sites: ProviderSite[] = [];

    public provider: any;
    constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
        this.sites = data.sites;
        this.provider = data;
    }
}
